"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlacementId = exports.AdServer = void 0;
var AdServer;
(function (AdServer) {
    AdServer["AFS"] = "afs";
    AdServer["Xandr"] = "xandr";
})(AdServer || (exports.AdServer = AdServer = {}));
var PlacementId;
(function (PlacementId) {
    PlacementId["Empty"] = "";
    PlacementId["Top1"] = "advt_top_1";
    PlacementId["Left1"] = "advt_left_1";
    PlacementId["Right1"] = "advt_right_1";
    PlacementId["Top2"] = "advt_top_2";
    PlacementId["Middle1"] = "advt_middle_1";
    PlacementId["Middle2"] = "advt_middle_2";
    PlacementId["Bottom1"] = "advt_bottom_1";
    PlacementId["RecircMiddle1"] = "advt_recirc_middle_1";
    PlacementId["RecircMiddle2"] = "advt_recirc_middle_2";
    PlacementId["AfsContainer1"] = "afs_container_1";
    PlacementId["AfsContainer2"] = "afs_container_2";
})(PlacementId || (exports.PlacementId = PlacementId = {}));
